export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AccordionWrapper.vue?vue&type=template&id=f0d63aa8&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/AccordionWrapper.vue?vue&type=template&id=f0d63aa8&scoped=true&
// module id = 202
// module chunks = 0